/**
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<[Error,{}]>|Promise<[null,T]>}
 */
export async function handlePromise(promise) {
    return promise.then((data) => [null, data]).catch((error) => [error, {}])
}
